function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from 'react';
import { CustomTextField } from 'app/components/match/liveResult/CustomNumberTextField';
import { GridElement } from 'app/components/match/liveResult/updateScorer/sharedStyles';
import { Autocomplete, MenuItem } from '@mui/material';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { CustomPopperComponent } from 'app/components/match/liveResult/updateScorer/CustomPopperComponent';
const Container = styled.div.withConfig({
  componentId: "sc-nykrwl-0"
})(["display:flex;overflow:hidden;width:100%;"]);
const JerseyNumber = styled.div.withConfig({
  componentId: "sc-nykrwl-1"
})(["flex:0 0 28px;text-align:center;padding-right:4px;"]);
const Name = styled.div.withConfig({
  componentId: "sc-nykrwl-2"
})(["flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
export default function PlayerSelect(_ref) {
  let {
    players,
    show,
    error,
    control,
    defaultValue,
    ...props
  } = _ref;
  const options = useMemo(() => [{
    id: 'unbekannt',
    jerseyNumber: 0,
    lastName: 'Unbekannt',
    firstName: ''
  }, ...players], [players]);
  const initialValue = useMemo(() => {
    var _options$find;
    return (_options$find = options.find(player => player.id === defaultValue)) !== null && _options$find !== void 0 ? _options$find : null;
  }, [defaultValue, options]);
  return show && players.length ? /*#__PURE__*/React.createElement(GridElement, {
    "data-sentry-element": "GridElement",
    "data-sentry-component": "PlayerSelect",
    "data-sentry-source-file": "PlayerSelect.tsx"
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: props.name,
    render: _ref2 => {
      let {
        field: {
          onChange
        }
      } = _ref2;
      return /*#__PURE__*/React.createElement(Autocomplete, {
        onChange: (event, item) => {
          var _item$id;
          onChange((_item$id = item === null || item === void 0 ? void 0 : item.id) !== null && _item$id !== void 0 ? _item$id : '');
        },
        id: "player-select",
        options: options,
        fullWidth: true,
        PopperComponent: props => /*#__PURE__*/React.createElement(CustomPopperComponent, props),
        defaultValue: initialValue,
        getOptionLabel: option => "".concat(option.jerseyNumber ? "(".concat(option.jerseyNumber, ") ") : '').concat(option.lastName, " ").concat(option.firstName),
        renderOption: (props, option) => /*#__PURE__*/React.createElement(MenuItem, _extends({
          value: option.id
        }, props), /*#__PURE__*/React.createElement(Container, null, option.jerseyNumber ? /*#__PURE__*/React.createElement(JerseyNumber, null, option.jerseyNumber) : /*#__PURE__*/React.createElement(JerseyNumber, null), /*#__PURE__*/React.createElement(Name, null, "".concat(option.lastName, " ").concat(option.firstName)))),
        isOptionEqualToValue: (option, value) => option.id === value.id,
        renderInput: params => {
          var _error$message;
          return /*#__PURE__*/React.createElement(CustomTextField, _extends({}, params, props, {
            error: !!error,
            variant: "outlined",
            size: "small",
            helperText: (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : ''
          }));
        }
      });
    },
    "data-sentry-element": "Controller",
    "data-sentry-source-file": "PlayerSelect.tsx"
  })) : /*#__PURE__*/React.createElement(GridElement, {
    "data-sentry-element": "GridElement",
    "data-sentry-component": "PlayerSelect",
    "data-sentry-source-file": "PlayerSelect.tsx"
  });
}